import React from 'react';
import { Col, Row } from 'reactstrap';

import getEventTargetValue from '../../utils/get-event-target-value';
import ContactFilters from '../ContactFilters';
import ListContacts from './ListContacts';

class ListContactsWithFilters extends React.PureComponent {
  state = {
    filters: {
      brandId: [],
      brandCluster: [],
      opportunitySalesUnit: [],
      opportunityBusinessModel: [],
      opportunityCampaignObjective: [],
      opportunityCommercialPackageId: [],
      opportunityStage: [],
      productBusiness: [],
      campaignStartDate_after: null,
      campaignStartDate_before: null,
      campaignEndDate_after: null,
      campaignEndDate_before: null,
      campaignStatus: [],
      selfServiceActivated: [],
    },
  };

  handleFilterChange = e => {
    this.setState(state => ({
      filters: {
        ...state.filters,
        [e.target.name]: getEventTargetValue(e.target),
      },
    }));
  };

  render() {
    const { filters } = this.state;

    return (
      <Row>
        <Col sm={2} className="pt-2 border-right">
          <ContactFilters onChange={this.handleFilterChange} {...filters} />
        </Col>
        <Col sm={10}>
          <ListContacts search={this.state.filters} title="" />
        </Col>
      </Row>
    );
  }
}

export default ListContactsWithFilters;
